import { motion } from "motion/react";
import iconTourism from "@/assets/images/industries/tourism.webp";

export default function Tourism() {
  return (
    <section className="relative py-16 sm:py-32 min-h-[75vh] flex items-center bg-transparent">
      {/* Premium Glowing purple backdrop orb */}
      <div className="absolute top-1/2 left-1/3 -translate-y-1/2 w-[350px] h-[350px] bg-brand-purple/10 blur-[130px] rounded-full pointer-events-none transform-gpu translate-z-0 will-change-transform" />

      <div className="container relative z-10 mx-auto px-4 sm:px-6 max-w-7xl">
        <div className="grid gap-8 grid-cols-1 md:grid-cols-2 items-center">
          
          {/* Left Column: Heading and Info */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, type: "spring", stiffness: 100 }}
            className="flex flex-col space-y-6 text-left order-2 md:order-1"
          >
            <div>
              <h1 className="text-3xl sm:text-6xl font-extrabold tracking-tight text-white uppercase leading-tight">
                Tourism <span className="text-brand-purple">SaaS Solution</span>
              </h1>
              <div className="mt-4 h-1 w-20 bg-gradient-to-r from-brand-purple to-brand-electric rounded-full" />
            </div>

            <h3 className="text-lg sm:text-2xl font-bold text-slate-200 leading-snug">
              Enhancing travel experiences through smart digital platforms
            </h3>

            <p className="text-slate-400 text-sm sm:text-lg leading-relaxed max-w-xl">
              Enhance travel experiences with a digital platform for managing bookings, customers, and travel packages. Designed for agencies and tourism businesses.
            </p>

            <div className="pt-2">
              <motion.a
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                href="https://wa.me/601165095910?text=Hi%2C%20I'm%20interested%20in%20your%20Tourism%20SaaS%20Solution."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-xl bg-brand-purple px-8 py-3.5 text-sm font-semibold text-white hover:bg-brand-purple/95 transition-all shadow-[0_0_15px_rgba(139,92,246,0.4)] cursor-pointer"
              >
                Get Started
              </motion.a>
            </div>
          </motion.div>

          {/* Right Column: 3D Illustration Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, type: "spring", stiffness: 100 }}
            className="flex justify-center items-center order-1 md:order-2"
          >
            <div className="relative group max-w-[280px] xs:max-w-[350px] sm:max-w-[450px]">
              {/* Subtle background element glow */}
              <div className="absolute inset-0 bg-brand-purple/10 blur-3xl rounded-[3rem] scale-90 group-hover:scale-90 transition-transform duration-700" />
              
              <img
                src={iconTourism}
                alt="Tourism Illustration"
                className="w-full aspect-[4/3] object-cover rounded-[2.5rem] shadow-2xl border-4 border-white/10 relative z-10 animate-float-0"
                style={{ imageRendering: '-webkit-optimize-contrast' }}
              />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
